module.exports = __webpack_public_path__ + "static/img/signUp.a2ed089e.png";